<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col class="d-flex">
          <h1 class="text-uppercase font-weight-bold">Layout Camara: {{ $route.params.name }}</h1>
        </b-col>
        <b-col>
          <div class="float-right">
            <b-button
              class="mr-2"
              size="sm"
              @click.prevent="canEdit = !canEdit"
              v-if="$store.state.user.scope.includes('puede-modificar-layout')"
              ><i class="fa fa-2x fa-gear"></i
            ></b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="border-top border-bottom py-1">
        <b-col>
          <b-button v-if="canEdit" class="mr-2" size="sm" @click.prevent="addPosition"> Agregar posicion </b-button>
          <b-button v-if="canEdit" class="mr-2" size="sm" @click.prevent="descargarPDF"> Imprimir </b-button>
          <b-button v-if="canEdit" class="mr-2" size="sm" @click.prevent="resizable = !resizable">
            Redimensionar
          </b-button>
        </b-col>
        <b-col class="float-right">
          <div class="float-right">
            <b-button-group size="sm">
              <b-button :disabled="currentFloor === floors[0]" @click.prevent="prevFloor" size="sm"
                ><i class="fa fa-caret-left"></i
              ></b-button>
              <b-button disabled>Piso {{ currentFloor }}</b-button>
              <b-button
                :disabled="currentFloor === floors[floors.length - 1]"
                size="sm"
                class="float-right"
                @click.prevent="nextFloor"
                ><i class="fa fa-caret-right"></i
              ></b-button>
            </b-button-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col id="areaImprimir">
          <grid-layout
            :layout.sync="positions"
            :col-num="columns"
            :row-height="110"
            :is-draggable="canEdit"
            :is-resizable="resizable"
            :prevent-collision="true"
            :is-mirrored="false"
            :vertical-compact="false"
            :margin="[10, 10]"
            :use-css-transforms="true"
            @layout-updated="onLayoutUpdated"
          >
            <grid-item
              v-for="item in positions"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              :key="item.id"
              @moved="onMoved(item)"
              @resized="onResized(item)"
            >
              <b-card
                class="h-100 p-2"
                no-body
                :bg-variant="item.pallet_set.length > 0 ? 'danger-muted' : 'success-muted'"
              >
                <span>
                  <a v-if="canEdit" href="#" class="float-right" @click.prevent="removePosition(item.i)"
                    ><i class="fa fa-lg fa-close text-danger"></i
                  ></a>
                  <strong>
                    {{ item.name }} <br />
                    <template v-for="(pallet, palletIdx) in item.pallet_set">
                      <small :key="palletIdx"> {{ pallet }}</small> <br />
                    </template>
                    <qr-modal v-if="canEdit" :position="item"></qr-modal>
                  </strong>
                </span>
              </b-card>
            </grid-item>
          </grid-layout>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import QrModal from "./QrModal.vue";
import html2pdf from "html2pdf.js";

export default {
  name: "LayoutMain",
  components: {
    GridLayout,
    GridItem,
    QrModal
  },
  data() {
    return {
      canEdit: false,
      floors: [1, 2, 3, 4],
      currentFloor: 1,
      columns: 12,
      resizable: false,
      positions: []
    };
  },
  computed: {
    positionHeight() {
      return 120;
    }
  },
  methods: {
    toggleOverlay() {
      this.$store.dispatch("toggleOverlay");
    },
    onMoved(item) {
      this.updatePosition(item);
    },
    onResized(item) {
      this.updatePosition(item);
    },
    onLayoutUpdated(layout) {
      console.log("onLayoutUpdated", layout);
    },
    removePosition(index) {
      this.toggleOverlay();
      this.$axios
        .delete(`/storage/position/${index}/`)
        .then(() => {
          this.positions = this.positions.filter((item) => item.i !== index);
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast("Error al eliminar la posicion", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          this.toggleOverlay();
        });
    },
    async addPosition() {
      this.toggleOverlay();
      const config = {
        x: 0,
        y: 0,
        w: 1,
        h: 1
      };
      const payload = {
        config,
        floor: this.currentFloor,
        name: "auto", // Esto se construye automaticamente con signals
        room: parseInt(this.$route.params.id)
      };

      try {
        const response = await this.$axios.post("/storage/position/", payload);
        const item = {
          x: response.data.config.x,
          y: response.data.config.y,
          w: response.data.config.w,
          h: response.data.config.h,
          i: response.data.id,
          name: response.data.name,
          pallet_set: response.data.pallet_set
        };
        this.positions.push(item);
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Error al agregar posicion", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.toggleOverlay();
      }
    },
    updatePositionName(oldName, newName) {
      this.positions.filter((item) => item.name === oldName)[0].name = newName;
    },

    updatePosition(item) {
      this.toggleOverlay();

      const payload = {
        name: "auto",
        config: {
          x: item.x,
          y: item.y,
          w: item.w,
          h: item.h
        }
      };
      try {
        this.$axios.patch(`/storage/position/${item.i}/`, payload).then((res) => {
          this.updatePositionName(item.name, res.data.name);
        });
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Error al actualizar posicion", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.toggleOverlay();
      }
    },
    getPositions() {
      this.toggleOverlay();
      this.$axios
        .get(`/storage/position/?expand=pallet_set&room=${this.$route.params.id}&floor=${this.currentFloor}`)
        .then((response) => {
          this.positions = response.data.map((item) => {
            return {
              x: item.config.x,
              y: item.config.y,
              w: item.config.w,
              h: item.config.h,
              i: item.id,
              name: item.name,
              pallet_set: item.pallet_set
            };
          });
        })
        .catch((error) => {
          console.log(error);
          this.$bvToast.toast("Error al obtener posiciones", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          this.toggleOverlay();
        });
    },
    nextFloor() {
      if (this.currentFloor < this.floors.length) {
        this.currentFloor++;
        this.getPositions();
      }
    },
    prevFloor() {
      if (this.currentFloor > 1) {
        this.currentFloor--;
        this.getPositions();
      }
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "png" },
        filename: "reporte.pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "legal", orientation: "landscape" }
      };
      html2pdf(element, opt);
    }
  },
  mounted() {
    this.getPositions();
  }
};
</script>

<style scoped>
/* .vue-grid-item {
  border: 1px solid #000;
  background: rgb(139, 139, 139) !important;
} */
</style>
